"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateTanzanianPhoneNumber = void 0;
function validateTanzanianPhoneNumber(phoneNumber) {
    const tanzanianPhoneNumberRegex = /^(?:\+?255|0)[-.\s]?(6[156789]|7[1345678])\d{7}$/;
    return tanzanianPhoneNumberRegex.test(phoneNumber);
}
exports.validateTanzanianPhoneNumber = validateTanzanianPhoneNumber;
